import { ToolTipConstants } from '../../../shared/constants/tool-tip-constants';
import { Component, OnInit, Input, ViewChild, OnDestroy, Directive  } from '@angular/core';
import { UtilService } from '../../../shared/services/util.service';
import { SelectListItem } from '../../../shared/models';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators, ReactiveFormsModule, FormControl } from '@angular/forms';
import { DestinationEnum } from '../../models/destination.enum';
import { Observable ,  Subscription ,  Subject } from 'rxjs';
import { map } from 'rxjs/operators';

import { Router, ActivatedRoute } from '@angular/router';
import { AppStateService } from '../../../shared/services/app-state.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ESitesNgbDateParserFormatter } from '../../services/date-parser-formatter';
import { NgbDateParserFormatter, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date-struct';
import * as AlertMessages from '../../../shared/constants/alert-messages.constants';
import { Store } from '@ngrx/store';
import { QuoteState } from '../../reducers';
import {
  GetTravelQuote
} from '../../actions/generate-quote';
import { QuoteActionTypes } from '../../actions/quote';
import { Actions, ofType } from '@ngrx/effects';
import * as moment from 'moment';
import { ButtonEnum } from '../../models/button.enum';
import { GoogleAnalyticsEventsService } from '../../../shared/services/google-analytics-events.service';
import { TravelFormData } from '../../models/form-data.interface';
import { DynamicButtonComponent } from '../../../shared/components/dynamic-button/dynamic-button.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatButtonModule } from '@angular/material/button';
import { SharedModule } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { CalendarComponent } from '../../../shared/components/calendar/calendar.component';
import { InputValidationComponent } from '../../../shared/components/input-validation/input-validation.component';
import { NgFor, NgIf, NgSwitch, NgSwitchCase, AsyncPipe } from '@angular/common';

@Component({
    selector: 'app-travel-hotel-sameday',
    templateUrl: './travel-hotel-sameday.component.html',
    styleUrls: ['./travel-hotel-sameday.component.scss'],
    providers: [
        { provide: NgbDateParserFormatter, useClass: ESitesNgbDateParserFormatter },
        ESitesNgbDateParserFormatter
    ],
    imports: [ReactiveFormsModule, NgFor, InputValidationComponent, NgbTooltipModule, NgIf, CalendarComponent, CalendarModule, SharedModule, MatButtonModule, NgSwitch, NgSwitchCase, NgSelectModule, DynamicButtonComponent, AsyncPipe]
})
export class TravelHotelSamedayComponent implements OnInit, OnDestroy {
  MAX_NUM_TRAVELERS = 9;
  travelHotelSamedayForm: UntypedFormGroup;
  states: SelectListItem[];
  errors: String[] = [];
  buttonDisabled = false;
  partnerName: string;
  tripCostTooltipMessage: string = ToolTipConstants.totalTripCost;

  destEnum = DestinationEnum;
  destSub: Subscription;
  quoteSub: Subscription;
  destTerm: string;
  destinations: Observable<Array<SelectListItem>>;
  minDateToday: Date;
  displayMonths: number;
  departureDate: Date;
  returnDate: Date;
  allDestinations: Array<SelectListItem> = [];
  filteredDestinations: Array<SelectListItem> = [];
  showSuggestions = false;
  destinationControl = new FormControl('');

  @Input() destinationEnum;
  @Input() quoteButtonText;
  @Input() quoteButtonColor;
  @Input() quoteButtonHoverColor;
  @Input() componentId: string;
  @ViewChild('rangeDatePicker', { static: true }) rangeDatePicker;

  private destSelection = new Subject<String>();
  destSelectionObservable$: Observable<
    String
  > = this.destSelection.asObservable();

  constructor(
    private formBuilder: UntypedFormBuilder,
    private utilService: UtilService,
    private _dateFormatter: ESitesNgbDateParserFormatter,
    private router: Router,
    private route: ActivatedRoute,
    private appStateService: AppStateService,
    private store: Store<QuoteState>,
    private action$: Actions,
    private ga: GoogleAnalyticsEventsService
  ) {
    this.travelHotelSamedayForm = this.formBuilder.group({
      departureReturnDate: [''],
      totalTripCost: new UntypedFormControl('', [
        Validators.required,
        Validators.pattern(/^(\d+|\d+\.\d{1,2})$/)
      ]),
      destination: '',
      state: ['', Validators.required],
      numTravelers: [1, Validators.required]
    });
  }

  ngOnInit() {
    this.utilService.getStates().subscribe(states => {
      this.states = states;
    });

    this.destinations = this.utilService.getDestinations();
    this.utilService.getDestinations().subscribe(destList => {
    this.allDestinations = destList;
    });

    this.partnerName = this.route.snapshot.params['partner'];

    const sessionQuoteForm = this.appStateService.getQuoteForm() as TravelFormData;

    if (typeof sessionQuoteForm !== 'undefined' && sessionQuoteForm !== null) {
      // Session Storage stores all values as string. The Departure and Return date will need to be convert it to
      // Date objects before the calendar can parse it.
      const departureReturnDate = [new Date(sessionQuoteForm.departureDate), new Date(sessionQuoteForm.returnDate)];

      this.travelHotelSamedayForm.patchValue({
        departureReturnDate: departureReturnDate,
        destination: sessionQuoteForm.destination,
        numTravelers: sessionQuoteForm.numTravelers,
        state: sessionQuoteForm.state,
        totalTripCost: sessionQuoteForm.cost
      });
      this.destinationControl.setValue(sessionQuoteForm.destination || '');
    }
    this.destinationControl.valueChanges.subscribe(value => {
      this.travelHotelSamedayForm.get('destination').setValue(value);
    });

    this.displayMonths = window.innerWidth >= 768
      ? 2
      : 1;

    this.today();
  }


  onClose() {
    this.setDateValidation();
    this.utilService.closeModal(this.rangeDatePicker);
  }

  onSelect() {
    // Close datepicker if end date is selected.
    if (this.rangeDatePicker.value[1]) {
      this.rangeDatePicker.overlayVisible = false;
    }
  }

  setDateValidation() {
    if (!this.rangeDatePicker.value[0]) {
      this.travelHotelSamedayForm.controls['departureReturnDate'].setErrors(Validators.required);
    }
  }

  get numTravelersArray(): number[] {
    const arr = [];
    let i = 1;
    while (arr.push(i++) < this.MAX_NUM_TRAVELERS) {}
    return arr;
  }

  ngOnDestroy() {
    if (this.destSub) {
      this.destSub.unsubscribe();
    }
      if (this.quoteSub) {
      this.quoteSub.unsubscribe();
    }
  }
    onSubmit() {
    this.errors = [];
    this.setDateValidation();

    if (this.travelHotelSamedayForm.valid) {
      this.buttonDisabled = true;
      const quoteFormData = <TravelFormData>{
        state: this.state.value,
        cost: this.totalTripCost.value as number,
        destination: this.destination.value,
        departureDate: moment(this.departureReturnDate.value[0]).format('MM/DD/YYYY'),
        returnDate: moment(this.departureReturnDate.value[1]).format('MM/DD/YYYY'),
        numTravelers: this.numTravelers.value as number
      }
      this.store.dispatch(
        new GetTravelQuote(quoteFormData)
      );
      if (!this.quoteSub) {
        this.quoteSub = this.action$.pipe(
          ofType<any>(QuoteActionTypes.GetTravelQuoteSuccess),
          map(action => action.payload)
        ).subscribe(q => {
          this.buttonDisabled = false;
          this.ga.formSubmit(ButtonEnum.GetQuote);
          this.appStateService.clearManagePolicyState();
          this.appStateService.clearPurchaseState();
          this.appStateService.setPurchaseSessionActive(true);
          this.appStateService.setQuoteForm(quoteFormData);
          this.appStateService.setQuote(q);
          this.appStateService.broadcastQuote(q);
          this.router.navigateByUrl(`${this.partnerName}/policy/products`);
        });
      }
      this.action$.pipe(
          ofType<any>(QuoteActionTypes.GetTravelQuoteFailure),
          map(action => action.payload)
        ).subscribe((err: HttpErrorResponse) => {
          if (err.status === 400) {
            this.errors = this.utilService.getModelStateErrors(
              err.error.modelState
            );
          }
          if (this.errors.length === 0) {
            this.errors.push(AlertMessages.SERVICE_DOWN);
          }
          this.buttonDisabled = false;
        });

      this.action$.pipe(
        ofType<any>(QuoteActionTypes.GetCarRentalQuoteFailure),
        map(action => action.payload)
      ).subscribe((err: HttpErrorResponse) => {
          if (err.status === 400) {
            this.errors = this.utilService.getModelStateErrors(
              err.error.modelState
            );
          }
          if (this.errors.length === 0) {
            this.errors.push(AlertMessages.SERVICE_DOWN);
          }
          this.buttonDisabled = false;
        });
    } else {
      this.utilService.validateAllFormFields(this.travelHotelSamedayForm);
    }
  }

  today() {
    const d = new Date();
    d.setDate(d.getDate());
    this.minDateToday = d;
  }

  destSelected($event) {
    const value = $event ? $event.desc : '';
    this.destSelection.next(value);
  }

  get destination() {
    return this.travelHotelSamedayForm.get('destination');
  }
  get totalTripCost() {
    return this.travelHotelSamedayForm.get('totalTripCost');
  }
  get departureReturnDate() {
    return this.travelHotelSamedayForm.get('departureReturnDate');
  }
  get state() {
    return this.travelHotelSamedayForm.get('state');
  }
  get numTravelers() {
    return this.travelHotelSamedayForm.get('numTravelers');
  }
  get yesterday(): NgbDateStruct {
    return this.utilService.getYesterday();
  }
  filterDestinations(): void {
    const query = (this.destinationControl.value || '').toLowerCase().trim();
    if (query.length === 0) {
      this.showSuggestions = false;
      this.filteredDestinations = [];
      return;
    }
    this.filteredDestinations = this.allDestinations.filter(d =>
      d.desc.toLowerCase().includes(query)
    );
    this.showSuggestions = this.filteredDestinations.length > 0;
  }

  selectDestination(destination: SelectListItem) {
    this.destinationControl.setValue(destination.desc);
    this.showSuggestions = false;
    this.travelHotelSamedayForm.get('destination').setValue(destination.desc);
  }

  onFocus(): void {
    this.filterDestinations();
  }

  onBlur(): void {
    setTimeout(() => {
      this.showSuggestions = false;
    }, 200);
  }
}